import {createSlice} from '@reduxjs/toolkit'
import {saveAction, setLoaderAction, defaultInitState} from "./reducerDefaults";

export const cardSlice = createSlice({
    name: 'cards',
    initialState: defaultInitState,
    reducers: {
        saveCards: saveAction,
        loader: setLoaderAction
    },
})

// Action creators are generated for each case reducer function
export const {saveCards, loader} = cardSlice.actions

export default cardSlice.reducer
